export default class ResizePlugin {
    /**
     * Create a Resize Plugin.
     * @param {Object} config
     * @param {HTMLElement} config.container - Element you wish to resize
     * @param {Number} [config.paddingBuffer = 20] - Pixel value to act as a buffer on the amount of padding added
     */
    constructor({
        container = console.error('ResizePlugin expects a container property (HTMLElement)'),
        paddingBuffer = 20,
        shouldDisplayPadding = null,
    }) {
        this.container = container;
        this.paddingBuffer = paddingBuffer;
        this.shouldDisplayPadding = shouldDisplayPadding !== null ? shouldDisplayPadding : this.container.classList.contains('bbc-news-vj-shadow-dom');
        this.currentPadding = 0;
        this.postRender = this.postRender.bind(this);
    }

    /**
     * Calculates difference between container and space required by suggestions and applies supplemental padding to container to accomodate
     * @param {Object} els - References to lookup module elements
     */
    postRender(els) {
        if (!this.shouldDisplayPadding) {
            const suggestions = els.menu.getBoundingClientRect();
            const difference = Math.round(suggestions.height);
            const offset = difference + this.paddingBuffer;
            const paddingFix = difference < 0 ? 0 : offset;

            this.currentPadding = paddingFix;
            this.container.style.paddingBottom = `${this.currentPadding}px`;
        }
    }
}
